export default __webpack_public_path__ + "static/media/wallpaper_bg0.2102b0fc.png";